// ---- js/demo.js
/* SPEEDROT demos: a canvas with the game's 360x640 coordinate system where a bot plays real games and
   a tap hands you the controls. The home page uses the pieces; any <canvas data-demo="template"> on
   the site's game pages mounts itself and plays that mechanic's house games. */
(function (root) {
  'use strict';
  const SR = root.SR, W = SR.W, H = SR.H, D = SR.Draw;
  const reduced = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- a canvas with a touch/mouse thumb -----------------------------------------------------------------
  function Screen(canvas) {
    const self = this;
    this.cv = canvas; this.ctx = canvas.getContext('2d');
    this.input = SR.emptyInput(); this.edge = { tap: null, release: null, action: false };
    this.onTap = null; this.down = null;
    function logical(e) { const r = canvas.getBoundingClientRect(); return { x: (e.clientX - r.left) / r.width * W, y: (e.clientY - r.top) / r.height * H }; }
    canvas.addEventListener('pointerdown', function (e) {
      const p = logical(e);
      try { canvas.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
      self.input.x = p.x; self.input.y = p.y; self.input.down = true; self.input.active = true;
      self.edge.tap = p; self.down = p;
      if (self.onTap) self.onTap(p);
      e.preventDefault();
    });
    canvas.addEventListener('pointermove', function (e) { const p = logical(e); self.input.x = p.x; self.input.y = p.y; if (e.pointerType === 'mouse') self.input.active = true; });
    const up = function (e) {
      const p = logical(e);
      self.input.down = false;
      if (e.pointerType !== 'mouse') self.input.active = false;
      if (self.down) self.edge.release = { x: p.x, y: p.y, dx: p.x - self.down.x, dy: p.y - self.down.y };
      self.down = null;
    };
    canvas.addEventListener('pointerup', up);
    canvas.addEventListener('pointercancel', up);
  }
  Screen.prototype.begin = function () {
    const r = this.cv.getBoundingClientRect(), dpr = Math.min(2, root.devicePixelRatio || 1);
    const w = Math.max(1, Math.round(r.width * dpr)), h = Math.max(1, Math.round(r.height * dpr));
    if (this.cv.width !== w || this.cv.height !== h) { this.cv.width = w; this.cv.height = h; }
    this.ctx.setTransform(w / W, 0, 0, h / H, 0, 0);
    return this.ctx;
  };
  Screen.prototype.take = function () {
    const i = this.input;
    i.tap = this.edge.tap; i.release = this.edge.release; i.action = this.edge.action; i.dir = 0; i.moveX = 0;
    this.edge = { tap: null, release: null, action: false };
    return i;
  };
  Screen.prototype.clear = function () { this.edge = { tap: null, release: null, action: false }; };

  // ---- the intro card: command, title, cast and hint ----------------------------------------------------------
  const ROLES = {
    dodge: [['YOU', 'player'], ['AVOID', 'hazard']], catch: [['YOU', 'player'], ['CATCH', 'target'], ['NOT', 'hazard']],
    tap: [['TAP', 'target'], ['NOT', 'hazard']], mash: [['PUMP', 'target']], timing: [['STOP', 'player'], ['ON', 'target']],
    sort: [['LEFT', 'target'], ['RIGHT', 'hazard']], aim: [['FROM', 'player'], ['HIT', 'target'], ['NOT', 'hazard']],
    hold: [['YOU', 'player'], ['KEEP UP', 'target']], count: [['COUNT', 'target'], ['IGNORE', 'hazard']], find: [['FIND', 'target'], ['AMONG', 'hazard']],
    gap: [['YOU', 'player'], ['AVOID', 'hazard']]
  };
  function drawIntro(ctx, spec, t, dur) {
    D.bg(ctx, spec, t * 2, W, H, 1);
    ctx.fillStyle = 'rgba(0,0,0,.18)'; ctx.fillRect(0, 0, W, H);
    const k = Math.min(1, t / 0.25), s = reduced ? 1 : SR.ease.outBack(k);
    D.text(ctx, spec.verb, W / 2, H * 0.32, 70, { scale: 0.3 + 0.7 * s, rot: -0.06, fill: '#ffe14d', strokeW: 0.17, wrap: 330 });
    D.text(ctx, spec.title, W / 2, H * 0.32 + 82, 26, { wrap: 310, scale: Math.min(1, t / 0.3) });
    const row = (ROLES[spec.template] || []).filter(function (x) { return spec[x[1]]; });
    const x0 = W / 2 - (row.length - 1) * 48;
    row.forEach(function (x, i) {
      const cx = x0 + i * 96, y = H * 0.62, bob = Math.sin(t * 8 + i) * 4;
      ctx.fillStyle = 'rgba(0,0,0,.28)'; ctx.beginPath(); ctx.arc(cx, y + bob, 38, 0, 7); ctx.fill();
      D.emoji(ctx, spec[x[1]], cx, y + bob, 50);
      D.text(ctx, x[0], cx, y + 56, 16);
    });
    ctx.fillStyle = 'rgba(0,0,0,.45)'; D.roundRect(ctx, 30, H * 0.8 - 20, W - 60, 40, 20); ctx.fill();
    D.text(ctx, SR.T[spec.template].hint, W / 2, H * 0.8, 18, { stroke: false, fill: '#fff' });
    ctx.fillStyle = '#ffe14d'; ctx.fillRect(0, H - 8, W * Math.min(1, t / dur), 8);
  }

  // ---- a phone that demos games with a bot until you tap it ------------------------------------------------------
  function Player(canvas, opts) {
    this.screen = new Screen(canvas);
    this.specs = []; this.n = 0; this.spec = null; this.g = null; this.mode = 'demo'; this.t = 0; this.bot = {}; this.rng = SR.rng(3); this.idle = 0;
    this.onGame = opts && opts.onGame; this.onMode = opts && opts.onMode;
    this.visible = true;
    const self = this;
    this.screen.onTap = function () { if (self.mode === 'demo' || self.mode === 'done') self.tryIt(); };
    if ('IntersectionObserver' in root) new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; }).observe(canvas);
  }
  Player.prototype.load = function (specs) { this.specs = specs; this.n = 0; this.next(); };
  Player.prototype.next = function () {
    this.spec = this.specs[this.n++ % this.specs.length];
    this.demo();
    if (this.onGame) this.onGame(this.spec);
  };
  Player.prototype.demo = function () {
    this.mode = 'demo'; this.idle = 0; this.bot = {}; this.rng = SR.rng(SR.hash('db' + Math.random()));
    this.g = new SR.Micro(this.spec, { seed: SR.hash('dm' + Math.random()) });
    if (this.onMode) this.onMode('demo');
  };
  Player.prototype.tryIt = function () {
    this.mode = 'intro'; this.t = 0; this.g = new SR.Micro(this.spec, { seed: SR.hash('dt' + Math.random()) });
    if (this.onMode) this.onMode('play');
  };
  Player.prototype.step = function (dt) {
    const g = this.g;
    if (!g || !this.visible) return;
    this.t += dt;
    if (this.mode === 'demo') {
      if (g.status === 'play') g.step(dt, Object.assign(SR.emptyInput(), g.T.bot(g.s, g, this.bot, dt, this.rng) || {}));
      else { g.stepFx(dt); this.idle += dt; if (this.idle > 1) { if (this.specs.length > 1) this.next(); else this.demo(); } }
      this.screen.clear();
    } else if (this.mode === 'intro') { this.screen.clear(); if (this.t > 1.1) { this.mode = 'play'; this.t = 0; } }
    else if (this.mode === 'play') { g.step(dt, this.screen.take()); if (g.status !== 'play') { this.mode = 'done'; this.t = 0; } }
    else if (this.mode === 'done') { g.stepFx(dt); if (this.t > 1.4) this.demo(); }
    const ctx = this.screen.begin();
    if (this.mode === 'intro') drawIntro(ctx, this.spec, this.t, 1.1);
    else {
      D.frame(ctx, g, { hud: this.mode !== 'demo' });
      if (this.mode === 'done') D.text(ctx, g.status === 'win' ? g.spec.win : g.spec.lose, W / 2, H * 0.45, 52, { fill: g.status === 'win' ? '#ffe14d' : '#ff4d6d', rot: -0.06, wrap: 320 });
    }
  };

  // The games a demo phone plays for one mechanic: its house games, or a default dressing for bosses.
  function specsFor(template) {
    const T = SR.T[template];
    if (!T) return [];
    const house = SR.HOUSE.filter(function (h) { return h.template === template; });
    const list = house.length ? house : [{ template: template, title: T.name.toUpperCase() }];
    return list.map(function (h) { return SR.Tuner.tune(SR.normalizeSpec(h)).spec; });
  }

  let loopStarted = false;
  const players = [];
  function loop() {
    let last = performance.now();
    function frame(now) {
      requestAnimationFrame(frame);
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      if (root.document.hidden) return;
      players.forEach(function (p) { p.step(dt); });
    }
    requestAnimationFrame(frame);
  }
  function play(player) { players.push(player); if (!loopStarted) { loopStarted = true; loop(); } return player; }

  SR.Demo = { Screen: Screen, drawIntro: drawIntro, Player: Player, specsFor: specsFor, play: play, reduced: reduced };

  // Self-mounting phones on the site's game pages.
  function mountAll() {
    Array.prototype.forEach.call(root.document.querySelectorAll('canvas[data-demo]'), function (cv) {
      const id = cv.getAttribute('data-demo'), cap = root.document.querySelector('[data-demo-caption="' + id + '"]');
      const tag = cv.parentNode.querySelector('.phone-tag');
      const p = new Player(cv, {
        onGame: function (spec) { if (cap) cap.textContent = spec.title + ' · a bot is playing. Tap the phone to take a turn.'; },
        onMode: function (m) { if (tag) tag.textContent = m === 'play' ? 'YOUR TURN' : 'BOT DEMO · TAP TO PLAY'; }
      });
      p.load(specsFor(id));
      play(p);
    });
  }
  if (root.document) {
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', mountAll); else mountAll();
  }
})(window);
